<template>
  <v-card>
    <v-card-title>
      <v-col>
        <v-row>
          <span class="text-h5">
            {{ $t('ITEM.EDIT') }} {{ $t('APARTMENTS.ITEM') }}
            {{ apartment.name }}
          </span>
        </v-row>
        <v-row v-if="buildings.length === 1">
          <span class="text-h5"
            >({{ buildings[0].street }}, {{ buildings[0].name }})</span
          >
        </v-row>
      </v-col>
    </v-card-title>

    <v-card-text>
      <div v-if="errors.any()">
        <v-alert
          v-for="(message, index) in errors.getAllMessages()"
          :key="index"
          color="error"
          dark
          dense
        >
          {{ message }}
        </v-alert>
      </div>

      <div v-if="limitIsAchieved">
        <v-alert type="error">
          {{ $t('MESSAGE.DATA_FROM_NAME_FLOOR_DESCRIPTION_LIMIT_LENGTH') }}
        </v-alert>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <apartment-form
          v-model="newApartment"
          :errors="errors.getAll()"
          @update-prop="clearErrorByName($event)"
        >
          <template v-slot:buttons>
            <v-layout align-center justify-space-between row>
              <v-btn outlined text @click="$emit('cancel')">{{
                $t('BUTTON.CANCEL')
              }}</v-btn>

              <v-btn
                color="primary"
                :disabled="!valid"
                :loading="loading"
                @click="validate"
              >
                {{ $t('BUTTON.UPDATE') }}
              </v-btn>
            </v-layout>
          </template>
        </apartment-form>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import ApartmentForm from '@/components/apartments/components/ApartmentForm';
import errors from '@/modules/_global/mixins/errors';
import { cloneDeep } from 'lodash';

export default {
  name: 'ApartmentEdit',

  components: { ApartmentForm },

  mixins: [errors],

  props: {
    buildings: {
      type: Array,
      required: true
    },

    apartment: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    newApartment: {
      presentation: false
    },

    valid: true
  }),

  computed: {
    loading() {
      return this.$store.getters['loading'];
    },

    limitIsAchieved() {
      let sum = 0;

      try {
        sum += this.newApartment.name.length;
      } catch {
        sum += 0;
      }

      try {
        sum += this.newApartment.floor.length;
      } catch {
        sum += 0;
      }

      try {
        sum += this.newApartment.access_description.length;
      } catch {
        sum += 0;
      }

      return sum > 56;
    }
  },

  created() {
    this.newApartment = cloneDeep(this.apartment);
  },

  methods: {
    validate() {
      if (this.$refs.form.validate() && !this.limitIsAchieved) {
        // if(!this.apartment.building_id) {
        //     if (this.buildings.length === 1) {
        //         this.apartment.building_id = this.buildings[0].id
        //     }
        //     else {
        //         return this.error = {
        //                     data: {
        //                         errors: {
        //                             building: ["Building is not selected"]
        //                         }
        //                     }
        //                 }
        //     }
        // }

        this.$store
          .dispatch('apartment/update', {
            ...this.newApartment
          })
          .then(({ data }) => {
            this.$store.commit('snackbar/setSnack', {
              status: 'success',
              text: this.$t('MESSAGE.SUCCESS')
            });
            this.$emit('success', data);
          })
          .then(() => {
            this.$emit('refreshBuildings');
            this.$emit('cancel');
          })
          .catch(error => {
            this.handleErrorsByResponse(error.response);
            this.$store.commit('loading', false);
          });
      }
    }
  }
};
</script>
